import config from '@/config'
import router from '@/router'
import {
  ROUTE_NAMES,
} from '@/constant/routes'

const SET_PREVIOUS_ROUTE = 'SET_PREVIOUS_ROUTE'

const _state = {
  previousRoute: null,
}

const _getters = {
  isEnableAddinPowerpoint: (_, __, rootState) => rootState.isEnableAddinPowerpoint,
  isGuestUser: (_, __, rootState) => rootState.currentUser.isGuest,
  workingMode: (_, __, rootState) => rootState.workingMode,
  previousRoute: (state) => state.previousRoute,
}

const actions = {
  async backAction({ getters, dispatch }) {
    if (getters.isEnableAddinPowerpoint) {
      window.location.href = `${config.presenterDomain}/apps/presentations`
      return
    }
    dispatch('backV2Action')
  },
  async backV2Action({ getters, rootState }) {
    if (getters.isGuestUser) {
      window.location.href = 'https://ahaslides.com/'
      return
    }
    if (getters.workingMode === 'team') {
      router.push('/apps/team/workspace')
      return
    }

    // a vue-router route instance
    const spaPreviousRoute = getters.previousRoute
    const isDifferentSPARoute = spaPreviousRoute.name !== rootState.route.name
    // spa route -> back
    if (spaPreviousRoute.name && isDifferentSPARoute) {
      window.history.back()
      return
    }

    const browserPreviousRoute = document.referrer
    // external route -> presenation
    if (browserPreviousRoute === '') {
      router.push({ name: ROUTE_NAMES.PRESENTATIONS })
      return
    }

    // internal route -> back
    const url = new URL(browserPreviousRoute)
    if (url.origin.includes(config.appOrigin)) {
      // window.history.back()
      // Use this instead of window.history.back() because history.back does not work with a link that opens a new tab
      window.location.href = document.referrer
      return
    }

    router.push({ name: ROUTE_NAMES.PRESENTATIONS })
  },
  setPreviousRouteAction({ commit }, route) {
    commit(SET_PREVIOUS_ROUTE, route)
  },
}

const mutations = {
  [SET_PREVIOUS_ROUTE](state, route) {
    state.previousRoute = route
  },
}

const editor = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}

export default editor
